import { Form, Input } from 'antd';
import { useTranslation } from 'react-i18next';
import { ICON } from '../DsRequest/icon';

const CustomizeContent = () => {
    const { t } = useTranslation();
    return (
        <div>
            <div className="text-[#999999] font-semibold text-xs uppercase">
                {t('Customize your content')}
            </div>
            <div
                style={{ borderBottom: '1px solid #F2F2F2' }}
                className="w-full my-2"
            ></div>
            <div className="space-y-2 overflow-y-auto pr-2">
                <div className="bg-[#F5F0FF] flex items-center space-x-2 rounded-lg p-2 text-purple h-[50px]">
                    {ICON.SEVEN}
                    <span>{t('DisplayText')}</span>
                </div>
                <Form.Item
                    name={['thankyou', 'topic']}
                    label={
                        <span className="font-semibold text-xs">
                            {t('Title')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Input size="large" placeholder={t('Title')} />
                </Form.Item>
                <Form.Item
                    name={['thankyou', 'detail']}
                    label={
                        <span className="font-semibold text-xs">
                            {t('Text')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Input.TextArea rows={6} placeholder={t('Text')} />
                </Form.Item>
            </div>
        </div>
    );
};

export default CustomizeContent;
